import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.page.html',
  styleUrls: ['./blogs.page.scss'],
})
export class BlogsPage implements OnInit {
  Blogs;
  noData: boolean=true;
  blogData: any;
  title: any;
  subtitle: any;
  tags=[];
  author: any;
  banner: any;
  date: any;
  Randomcolor: string;
  constructor(
    private server: ServerService,
    public sanitizer: DomSanitizer,
    public globals: GlobalVariable,
    private route:ActivatedRoute,
    private router:Router,
  ) {
    let id = this.route.snapshot.params['id'];
    let title = this.route.snapshot.params['title'];
    console.log(id,title,'route id')
    this.getBlogs(id);



    this.blogData = this.router.getCurrentNavigation().extras?.state?.blog;
    console.log(this.blogData,'blog data')

  }

  ngOnInit() {

  }
  ionViewDidEnter(){

  }
  getColors() {
    let symbols = '0123456789ABCDEF';

    let color = '#';
    for (var i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)];
    }
    this.Randomcolor = color;
    console.log(this.Randomcolor);
  }
  getBlogs(id) {
    // this.globals.Loader();
    this.server.getBlogDetails(id).subscribe(
      (res) => {
        this.getColors();
      this.noData=false;

        // this.globals.loading.dismiss();

        console.log(res);
        if (res.status) {
          this.noData=false;
          this.title=res.data.title;
          this.subtitle=res.data.subtitle;
          let tags= res.data.tags;
          if(tags){
            this.tags= tags.split(',');

          }
         console.log(this.tags)
         this.author=res.data.author
         this.banner=res.data.image;
         this.date=res.data.date

          this.Blogs = this.sanitizer.bypassSecurityTrustHtml(
            res.data.DESCRIPTION
          );
        }
        else{
          this.noData=true;
        }
      },
      (err) => {
        // this.globals.loading.dismiss();
        this.globals.presentToast('Network error');
      }
    );
  }
}
